import {inject, bindable} from 'aurelia-framework';
import {UserMessageService} from '../../services/userMessageService'
import $ from "jquery"


@inject(UserMessageService)
export class UserMessageCustomElement {
    @bindable umName;
    constructor(userMessageService) {

        this.userMessageService = userMessageService;


        this.userErrors = [];
        this.userWarnings = [];


        this.nextId = 0;

    }

    attached() {
        this.userMessageService.setUserWarningCallback(this.umName, this.displayUserWarning.bind(this));
        this.userMessageService.setUserErrorCallback(this.umName, this.displayUserError.bind(this));
        this.userMessageService.setUserMessageCallback(this.umName, this.displayUserMessage.bind(this));

    }



    displayUserError(message) {
        var item = {id: this.nextId++, message: message};
       this.userErrors.push(item);
       if(this.userErrorDisplay != '' && this.userErrorDisplay != null)
       {
        setTimeout(() => {this.userErrorDisplay.focus();}, 1);
       }
       this.setFixBody();
    }

    displayUserWarning(message) {
      var item = {id: this.nextId++, message: message};
     this.userWarnings.push(item);
     if(this.userWarningDisplay != '' && this.userWarningDisplay != null)
     {
      setTimeout(() => {this.userWarningDisplay.focus();}, 1);
     }
     this.setFixBody();
  }



    closeError(item) {
        var index;
        for(var i = 0; i < this.userErrors.length; i++) {
            if(this.userErrors[i].id == item.id) {
                index = i;
                break;
            }

        }

        this.userErrors.splice(index, 1);

        this.setFixBody();

    }

     displayUserMessage(message) {
        this.userMessage = message;
        $(this.userMessageDisplay).fadeIn();
        //this.userMessageDisplay.style.display = "block";
        setTimeout(this.closeMessage.bind(this), 2000);
    }

    closeMessage() {
        //this.userMessageDisplay.style.display = "none";
         $(this.userMessageDisplay).fadeOut();
    }

    closeWarnings(item) {
      var index;
      for(var i = 0; i < this.userWarnings.length; i++) {
          if(this.userWarnings[i].id == item.id) {
              index = i;
              break;
          }

      }

      this.userWarnings.splice(index, 1);

      this.setFixBody();

  }

    setFixBody() {
        if(this.userErrors.length > 0)
          $('body').addClass('lock-position');
        else
          $('body').removeClass('lock-position');
      }

}
